import React, { useRef, useState, useEffect } from "react";
import { IconClock } from "../../assets/icons/icon-clock";

const OperatingHours = ({
  getDataOp,
  setgetDataOp,
  setIsOpen,
  IsOpen,
  setInputResponse,
  inputResponse,
}) => {
  const [days, setDays] = useState({
    Monday: false,
    Tuesday: false,
    Wednesday: false,
    Thursday: false,
    Friday: false,
    Saturday: false,
    Sunday: false,
  });


  const [time, setTime] = useState({
    Monday: { from: "08:00", to: "17:00" },
    Tuesday: { from: "08:00", to: "17:00" },
    Wednesday: { from: "08:00", to: "17:00" },
    Thursday: { from: "08:00", to: "17:00" },
    Friday: { from: "08:00", to: "17:00" },
    Saturday: { from: "08:00", to: "17:00" },
    Sunday: { from: "08:00", to: "17:00" },
  });

  const [weekdays, setWeekdays] = useState(false);
  const [weekend, setWeekend] = useState(false);

  useEffect(() => {
    if (getDataOp && Array.isArray(getDataOp)) {
        const updatedDays = {};
        const updatedTime = {};

        getDataOp.forEach(({ day, isChecked, time }) => {
            updatedDays[day] = isChecked;
            updatedTime[day] = {
                from: time?.from ? time.from.slice(0, 5) : "08:00",
                to: time?.to ? time.to.slice(0, 5) : "17:00",
            };
        });

        setDays(updatedDays);
        setTime(updatedTime);

        // Auto-check weekdays and weekends
        setWeekdays(updatedDays.Monday && updatedDays.Tuesday && updatedDays.Wednesday && updatedDays.Thursday && updatedDays.Friday);
        setWeekend(updatedDays.Saturday && updatedDays.Sunday);
    }
}, [getDataOp]);

  

  // Refs for each day's time input
  const timeRefs = {
    monday: { from: useRef(null), to: useRef(null) },
    tuesday: { from: useRef(null), to: useRef(null) },
    wednesday: { from: useRef(null), to: useRef(null) },
    thursday: { from: useRef(null), to: useRef(null) },
    friday: { from: useRef(null), to: useRef(null) },
    saturday: { from: useRef(null), to: useRef(null) },
    sunday: { from: useRef(null), to: useRef(null) },
  };

  const handleDayChange = (day) => {
    const updatedDays = { ...days, [day]: !days[day] };
    setDays(updatedDays);

    setTime((prevTime) => ({
        ...prevTime,
        [day]: updatedDays[day] 
            ? { from: prevTime[day].from || "08:00", to: prevTime[day].to || "17:00" } 
            : { from: null, to: null }, 
    }));

    // Auto-check "Weekdays" if Mon-Fri are all checked
    const isWeekdaysChecked =
        updatedDays.Monday &&
        updatedDays.Tuesday &&
        updatedDays.Wednesday &&
        updatedDays.Thursday &&
        updatedDays.Friday;
    setWeekdays(isWeekdaysChecked);

    // Auto-check "Weekend" if both Saturday & Sunday are checked
    setWeekend(updatedDays.Saturday && updatedDays.Sunday);
};




const handleWeekdaysChange = () => {
  const newState = !weekdays;
  setWeekdays(newState);

  setDays((prevState) => ({
      ...prevState,
      Monday: newState,
      Tuesday: newState,
      Wednesday: newState,
      Thursday: newState,
      Friday: newState,
  }));

  setTime((prevTime) => ({
      ...prevTime,
      Monday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
      Tuesday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
      Wednesday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
      Thursday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
      Friday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
  }));
};
  

const handleWeekendChange = () => {
  const newState = !weekend;
  setWeekend(newState);

  setDays((prevState) => ({
      ...prevState,
      Saturday: newState,
      Sunday: newState,
  }));

  setTime((prevTime) => ({
      ...prevTime,
      Saturday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
      Sunday: newState ? { from: "08:00", to: "17:00" } : { from: null, to: null },
  }));
};


  const handleTimeChange = (day, field, value) => {
    setTime((prevState) => ({
      ...prevState,
      [day]: {
        ...prevState[day],
        [field]: value,
      },
    }));
  };

  const fetchResponse = () => {
  const response = Object.keys(days).map((day) => ({
    day,
    isChecked: days[day],
    time: time[day],
  }));

  // Filter only the active days
  const activeDays = response.filter((day) => day.isChecked);

  if (activeDays.length === 0) {
    setInputResponse("No active days");
    return;
  }

  const groupedDays = [];
  let currentGroup = null;

  // Group active days by their time range
  for (const currentDay of activeDays) {
    if (
      currentGroup &&
      currentDay.time.from === currentGroup.time.from &&
      currentDay.time.to === currentGroup.time.to
    ) {
      // If the time matches the current group, add the day to the group
      currentGroup.days.push(currentDay.day);
    } else {
      // If the time doesn't match, close the previous group (if any) and start a new one
      if (currentGroup) {
        groupedDays.push(currentGroup);
      }
      currentGroup = { days: [currentDay.day], time: currentDay.time };
    }
  }

  // Push the last group
  if (currentGroup) {
    groupedDays.push(currentGroup);
  }

  // Generate the final response string
  const responseText = groupedDays
    .map((group) => {
      // Use getDayRange to handle active days only
      const dayRange = getDayRange(group.days);
      return `${dayRange}: ${group.time.from} to ${group.time.to}`;
    })
    .join(", ");

  setgetDataOp(response);
  setInputResponse(responseText);
  setIsOpen(false);
};

// Helper function to get the day range based on active days
function getDayRange(days) {
  const dayOrder = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const sortedDays = days
    .map((day) => dayOrder.indexOf(day))
    .sort((a, b) => a - b)
    .map((index) => dayOrder[index]);


  const ranges = [];
  let rangeStart = sortedDays[0];

  for (let i = 1; i < sortedDays.length; i++) {
    const currentDay = sortedDays[i];
    const previousDay = sortedDays[i - 1];

    // If the current day isn't consecutive, close the previous range
    if (
      dayOrder.indexOf(currentDay) !== dayOrder.indexOf(previousDay) + 1
    ) {
      ranges.push(
        rangeStart === previousDay
          ? capitalize(rangeStart)
          : `${capitalize(rangeStart)} to ${capitalize(previousDay)}`
      );
      rangeStart = currentDay;
    }
  }

  // Push the last range
  ranges.push(
    rangeStart === sortedDays[sortedDays.length - 1]
      ? capitalize(rangeStart)
      : `${capitalize(rangeStart)} to ${capitalize(
          sortedDays[sortedDays.length - 1]
        )}`
  );

  return ranges.join(", ");
}

// Helper function to capitalize the first letter of a string
function capitalize(day) {
  return day.charAt(0).toUpperCase() + day.slice(1);
}


  return (
    <div className="p-1 mx-auto">
      <h2 className="text-[18px] font-[600] mb-4">Operating Hours</h2>

      <div className="flex items-center mb-2 min-h-[35px] font-mont text-[16px] font-[600]">
        <input
          type="checkbox"
          id="weekdays"
          checked={weekdays}
          onChange={handleWeekdaysChange}
          className="mr-2"
        />
        <label htmlFor="weekdays" className="text-lg  font-medium">
          Weekdays
        </label>
      </div>

      <div className="flex items-center mb-2 min-h-[35px] font-mont text-[16px] font-[600]">
        <input
          type="checkbox"
          id="weekend"
          checked={weekend}
          onChange={handleWeekendChange}
          className="mr-2"
        />
        <label htmlFor="weekend" className="text-lg  font-medium">
          Weekend
        </label>
      </div>

      {Object.keys(days).map((day) => (
        <div key={day} className="flex items-center justify-between mb-2 min-h-[35px]">
          <div>
            <input
              type="checkbox"
              id={day}
              checked={days[day]}
              onChange={() => handleDayChange(day)}
              className="mr-2"
            />
            <label htmlFor={day} className="capitalize text-lg  font-medium">
              {day}
            </label>
          </div>
          {days[day] && (
            <div className="flex items-center">
              
              <div className="relative">
                  <label className="text-sm font-normal">From:</label>
                  <input
                    type="time"
                    value={time[day].from}
                    onChange={(e) => handleTimeChange(day, "from", e.target.value)}
                    //ref={timeRefs[day].from || null} // Assign the ref
                    className="ml-2 p-1 border rounded shadow-sm focus:ring focus:ring-blue-300"
                  />
                  
                  <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                      <IconClock />
                  </div>
              </div>

              <div className="relative">
                  <label className="ml-2 text-sm font-normal">To:</label>
                  <input
                    type="time"
                    value={time[day].to}
                    onChange={(e) => handleTimeChange(day, "to", e.target.value)}
                    //ref={timeRefs[day].to || null} // Assign the ref
                    className="ml-2 p-1 border rounded shadow-sm focus:ring focus:ring-blue-300"
                  />
                  <div className="absolute inset-y-0 end-0 top-0 flex items-center pe-3.5 pointer-events-none">
                      <IconClock />
                  </div>
              </div>
            </div>
          )}
        </div>
      ))}

      <button
        onClick={fetchResponse}
        className="mt-4 px-4 py-2 bg-[#245cea] text-white rounded shadow hover:bg-white border hover:border-[#245cea] font-[500] hover:text-[#1a1a1b] hover: "
      >
        Add hours
      </button>
    </div>
  );
};

export default OperatingHours;
